import { render, staticRenderFns } from "./MediaInfo.vue?vue&type=template&id=4618511d&scoped=true&lang=pug"
import script from "./MediaInfo.vue?vue&type=script&lang=js"
export * from "./MediaInfo.vue?vue&type=script&lang=js"
import style0 from "./MediaInfo.vue?vue&type=style&index=0&id=4618511d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4618511d",
  null
  
)

export default component.exports